<nb-layout>
    <nb-layout-header fixed>
        <app-company-header></app-company-header>
    </nb-layout-header>

    <nb-layout-column>
        <div class="container">
            <router-outlet></router-outlet>
        </div>
    </nb-layout-column>
    <nb-layout-footer>
        <app-company-footer></app-company-footer>
    </nb-layout-footer>
</nb-layout>


